import { Appointment, utils } from 'kb-shared';

import { PatientAppointmentsResponse } from './Appointments.types';

const { inFutureWithDelay } = utils;

// logic is changed in a way that appointment are regarded as future appointments for 1 hour after they are started
export const filterAppointmentsByStartTime = (
  appointmentsData: PatientAppointmentsResponse | undefined,
  filterPastAppointment = false
): Appointment[] =>
  appointmentsData?.appointments?.filter((a: Appointment) => {
    if (!filterPastAppointment) {
      return inFutureWithDelay(a.startTime, 60);
    } else {
      return !inFutureWithDelay(a.startTime, 60);
    }
  }) || [];

export const getPastAppointments = (
  appointmentsData: PatientAppointmentsResponse | undefined
): Appointment[] => {
  return filterAppointmentsByStartTime(appointmentsData, true).sort(compareByStartTimeDescending);
};

export const getFutureAppointments = (
  appointmentsData: PatientAppointmentsResponse | undefined
): Appointment[] => {
  return filterAppointmentsByStartTime(appointmentsData, false).sort(compareByStartTimeAscending);
};

export const compareByStartTimeAscending = (a: Appointment, b: Appointment): number => {
  return new Date(a.startTime).getTime() - new Date(b.startTime).getTime();
};

export const compareByStartTimeDescending = (a: Appointment, b: Appointment): number => {
  return new Date(b.startTime).getTime() - new Date(a.startTime).getTime();
};
